import { getDefaultPathIndexes } from '@exodus/asset-lib';
import { WalletAccountNotFoundError } from '../errors/errors.js';
const createPublicKeyProviderApi = ({ publicKeyProvider, assetSources, assetsModule, walletAccountsAtom, }) => {
    const getKeyIdentifier = async (params) => {
        const { walletAccount: walletAccountName, assetName } = params;
        const walletAccounts = await walletAccountsAtom.get();
        const asset = assetsModule.getAsset(assetName);
        const walletAccount = walletAccounts[walletAccountName];
        if (!walletAccount) {
            throw new WalletAccountNotFoundError(walletAccountName);
        }
        const { chainIndex: defaultChainIndex, addressIndex: defaultAddressIndex } = getDefaultPathIndexes({
            asset,
            walletAccount,
            compatibilityMode: walletAccount.compatibilityMode,
        });
        const { purpose = await assetSources.getDefaultPurpose({
            walletAccount: walletAccountName,
            assetName,
        }), chainIndex = defaultChainIndex, addressIndex = defaultAddressIndex, } = params;
        return asset.api.getKeyIdentifier({
            purpose,
            accountIndex: walletAccount.index,
            chainIndex,
            addressIndex,
            compatibilityMode: walletAccount.compatibilityMode,
        });
    };
    return {
        publicKeyProvider: {
            async getPublicKey(params) {
                if ('keyIdentifier' in params) {
                    return publicKeyProvider.getPublicKey(params);
                }
                return publicKeyProvider.getPublicKey({
                    keyIdentifier: await getKeyIdentifier(params),
                    walletAccount: params.walletAccount,
                });
            },
            async getExtendedPublicKey(params) {
                if ('keyIdentifier' in params) {
                    return publicKeyProvider.getExtendedPublicKey(params);
                }
                return publicKeyProvider.getExtendedPublicKey({
                    keyIdentifier: await getKeyIdentifier(params),
                    walletAccount: params.walletAccount,
                });
            },
        },
    };
};
const publicKeyProviderApiDefinition = {
    id: 'publicKeyProviderApi',
    type: 'api',
    factory: createPublicKeyProviderApi,
    dependencies: ['publicKeyProvider', 'assetSources', 'assetsModule', 'walletAccountsAtom'],
};
export default publicKeyProviderApiDefinition;
